export interface SymbolOption {
  name: string;
  description?: string;
}

/** Symbols matching what was typed: names starting with it first, then names or descriptions containing it. */
export function matchSymbols(options: readonly SymbolOption[], query: string, limit = 50): SymbolOption[] {
  const q = query.trim().toLowerCase();
  if (q === '') return options.slice(0, limit);
  const starts: SymbolOption[] = [];
  const contains: SymbolOption[] = [];
  for (const o of options) {
    const name = o.name.toLowerCase();
    if (name.startsWith(q)) starts.push(o);
    else if (name.includes(q) || (o.description ?? '').toLowerCase().includes(q)) contains.push(o);
  }
  return [...starts, ...contains].slice(0, limit);
}
